import { PermissionEnum } from '@/consts/roles';
import { User } from '@/redux/auth/authTypes';
import { TFunction } from 'i18next';
import {
  FaBoxes,
  FaChartLine,
  FaClock,
  FaCog,
  FaReceipt,
  FaShoppingCart,
  FaUtensils,
} from 'react-icons/fa';

interface MenuItem {
  key: string;
  icon?: React.ReactNode;
  label: string;
  url?: string;
  children?: MenuItem[];
  permissions?: PermissionEnum[];
  requireOwner?: boolean;
  requireSuperAdmin?: boolean;
}

// const userHasPermissions = (user: User | null) => {
//   return (permissions: PermissionEnum[] = []) => {
//     if (!user) return false;
//     if (permissions.length === 0) return true;
//     return permissions.every((permission) => user.role.permissions.includes(permission));
//   };
// };

// const filterMenuItems = (
//   items: MenuItem[],
//   hasPermission: (perms: PermissionEnum[]) => boolean,
//   isOwner: boolean,
//   isSuperAdmin: boolean
// ): MenuItem[] => {
//   return items
//     .filter((item) => {
//       if (item.requireOwner && !isOwner) return false;
//       if (item.requireSuperAdmin && !isSuperAdmin) return false;
//       if (item.permissions && !hasPermission(item.permissions)) return false;
//       return true;
//     })
//     .map((item) => ({
//       ...item,
//       children: item.children
//         ? filterMenuItems(item.children, hasPermission, isOwner, isSuperAdmin)
//         : undefined,
//     }))
//     .filter((item) => !item.children || item.children.length > 0);
// };

export const generateItems = (t: TFunction, user: User | null) => {
  if (!user) return [];

  const menuItems: MenuItem[] = [
    {
      key: '1',
      icon: <FaShoppingCart size={20} />,
      label: t('sales'),
      url: '/',
    },
    {
      key: '2',
      icon: <FaReceipt size={20} />,
      label: t('receipts'),
      url: '/receipts',
    },
    {
      key: '3',
      icon: <FaClock size={20} />,
      label: t('shift'),
      url: '/shift',
    },
    {
      key: '3-1',
      icon: <FaChartLine size={20} />,
      label: t('shift_analytics') || 'Shift Analytics',
      url: '/shift-analytics',
    },
    {
      key: '3-2',
      icon: <FaUtensils size={20} />,
      label: t('kds') || 'KDS',
      url: '/kds',
    },
    {
      key: '4',
      icon: <FaBoxes size={20} />,
      label: t('items'),
      children: [
        { key: '4-1', label: t('all-items'), url: '/items/all' },
        { key: '4-2', label: t('categories'), url: '/items/categories' },
        { key: '4-3', label: t('modifiers'), url: '/items/modifiers' },
        { key: '4-4', label: t('discounts'), url: '/items/discounts' },
      ],
    },
    {
      key: '5',
      icon: <FaCog size={20} />,
      label: t('settings'),
      url: '/settings',
    },
  ];

  return menuItems;
};
